import { IataCodeModel } from '../models/iata-code.model';


/**
 * Above you could find a small sql-code-snippet which helps you to match cityId's and / or countryId's to iata-codes
 **/
// tslint:disable max-line-length
// SELECT
// a.iata,
// 	CONCAT('BT09-', a.city_id + 10000) AS city,
// 	CONCAT('GT11-', country.code_alpha2) AS country
// FROM airport a
// INNER JOIN city ON a.city_id = city.id
// INNER JOIN country ON city.country_id = country.id
// WHERE a.iata IN ('AAH', 'AAL', 'AAR', 'ABJ', 'ABZ', 'ACE', 'ADA', 'ADB', 'ADD', 'ADL', 'ADZ', 'AEP', 'AGA', 'AGP', 'AGT', 'AHO', 'AJA', 'AJR', 'AKL', 'ALA', 'ALC', 'ALG', 'ALY', 'AMM', 'AMS', 'ANA', 'ANC', 'ANU', 'AOI', 'AOK', 'APF', 'AQJ', 'ARI', 'ARK', 'ARN', 'ASB', 'ASR', 'ASU', 'ASW', 'ATH', 'ATL', 'AUA', 'AUH', 'AUS', 'AYQ', 'AYT', 'AZS', 'BAH', 'BAQ', 'BAX', 'BBK', 'BCN', 'BDS', 'BEG', 'BER', 'BEY', 'BFS', 'BGI', 'BGO', 'BGR', 'BGY', 'BHX', 'BHZ', 'BIA', 'BIO', 'BIQ', 'BJL', 'BJR', 'BJV', 'BKI', 'BKK', 'BLQ', 'BLR', 'BNA', 'BNJ', 'BOB', 'BOD', 'BOG', 'BOJ', 'BOM', 'BON', 'BOS', 'BPN', 'BRC', 'BRE', 'BRI', 'BRN', 'BRS', 'BRU', 'BSB', 'BSH', 'BSL', 'BTS', 'BUD', 'BUE', 'BUF', 'BUH', 'BUY', 'BVC', 'BWE', 'BWK', 'BZC', 'BZN', 'CAG', 'CAI', 'CAS', 'CCC', 'CCU', 'CDG', 'CEB', 'CEG', 'CEI', 'CFU', 'CGB', 'CGK', 'CGN', 'CHC', 'CHQ', 'CIA', 'CIY', 'CJC', 'CLJ', 'CLO', 'CLW', 'CLY', 'CMB', 'CMN', 'CND', 'CNS', 'CNX', 'COK', 'COS', 'CPH', 'CPT', 'CTA', 'CTG', 'CTU', 'CUN', 'CUR', 'CUZ', 'CWB', 'CWL', 'CXR', 'CYR', 'DAB', 'DAC', 'DAD', 'DAR', 'DBV', 'DDI', 'DEL', 'DEN', 'DFW', 'DJE', 'DKR', 'DLM', 'DME', 'DOH', 'DPS', 'DRS', 'DTM', 'DTW', 'DUB', 'DUR', 'DUS', 'DWC', 'DXB', 'DYU', 'EAS', 'EBB', 'ECN', 'EDI', 'EDO', 'EFL', 'ERF', 'ESB', 'ESU', 'EVN', 'EWR', 'EYW', 'EZE', 'FAO', 'FCO', 'FDF', 'FDH', 'FEZ', 'FIH', 'FLL', 'FLN', 'FLR', 'FMY', 'FNC', 'FOR', 'FPO', 'FRA', 'FRU', 'FSC', 'FTE', 'FUE', 'GCJ', 'GDN', 'GGT', 'GIG', 'GLA', 'GLF', 'GND', 'GOA', 'GOI', 'GOT', 'GPA', 'GRJ', 'GRO', 'GRU', 'GRX', 'GRZ', 'GUA', 'GVA', 'GWY', 'GYE', 'GZP', 'GZT', 'HAJ', 'HAM', 'HAN', 'HAV', 'HDF', 'HEL', 'HER', 'HHQ', 'HKG', 'HKO', 'HKT', 'HND', 'HNL', 'HOG', 'HOR', 'HOU', 'HRG', 'HVB', 'IAS', 'IBZ', 'ICN', 'IFN', 'IGU', 'IKA', 'IKT', 'IND', 'INN', 'INV', 'IPW', 'ISB', 'ISM', 'IST', 'ITM', 'ITO', 'IXB', 'IXL', 'JAI', 'JER', 'JFK', 'JKG', 'JMK', 'JNB', 'JNP', 'JOG', 'JRO', 'JSH', 'JSI', 'JTR', 'KAJ', 'KAO', 'KAT', 'KBV', 'KCH', 'KEF', 'KGL', 'KGS', 'KIX', 'KLU', 'KLX', 'KMG', 'KOA', 'KRK', 'KRT', 'KTM', 'KTT', 'KTW', 'KUA', 'KUL', 'KVA', 'KYL', 'LAS', 'LAX', 'LBA', 'LBD', 'LBV', 'LCA', 'LCY', 'LDY', 'LED', 'LEI', 'LEJ', 'LFW', 'LGA', 'LGB', 'LGK', 'LGW', 'LHR', 'LIH', 'LIL', 'LIM', 'LIN', 'LIO', 'LIR', 'LIS', 'LJU', 'LLW', 'LNZ', 'LON', 'LOP', 'LPA', 'LPB', 'LPL', 'LPQ', 'LRM', 'LTN', 'LUN', 'LUQ', 'LUX', 'LXA', 'LXR', 'LYS', 'MAA', 'MAD', 'MAH', 'MAN', 'MAO', 'MBA', 'MBJ', 'MCM', 'MCO', 'MCT', 'MDC', 'MDE', 'MDL', 'MDQ', 'MDZ', 'MEL', 'MES', 'MEX', 'MFM', 'MGA', 'MHD', 'MHG', 'MIA', 'MIL', 'MIR', 'MJT', 'MJV', 'MLA', 'MLE', 'MNL', 'MOW', 'MPL', 'MPM', 'MRS', 'MRU', 'MRV', 'MSQ', 'MSY', 'MUB', 'MUC', 'MVD', 'MXP', 'NAN', 'NAP', 'NAS', 'NAT', 'NBE', 'NBO', 'NCE', 'NCL', 'NDJ', 'NDR', 'NGO', 'NQY', 'NRN', 'NRT', 'NSA', 'NSI', 'NTE', 'NUE', 'NYC', 'OGG', 'OHL', 'OLB', 'OPO', 'ORB', 'ORD', 'ORE', 'ORK', 'ORY', 'OSL', 'OSS', 'OTP', 'OUA', 'OUD', 'OVD', 'OXB', 'OXF', 'PAR', 'PAS', 'PBM', 'PCN', 'PDL', 'PDP', 'PDX', 'PEG', 'PEK', 'PEN', 'PER', 'PFO', 'PGD', 'PHL', 'PHX', 'PID', 'PIE', 'PIT', 'PLZ', 'PMC', 'PMI', 'PMO', 'PNA', 'PNH', 'PNT', 'POA', 'POP', 'POZ', 'PQC', 'PRG', 'PRI', 'PSA', 'PSR', 'PTP', 'PTY', 'PUJ', 'PUQ', 'PUX', 'PUY', 'PVG', 'PVK', 'PXO', 'QFB', 'QIN', 'QKA', 'QMZ', 'QPO', 'QQX', 'QQY', 'QWU', 'QYN', 'RAI', 'RAK', 'RAR', 'RBA', 'REC', 'REP', 'REU', 'RGN', 'RHO', 'RIO', 'RIX', 'RJK', 'RKT', 'RLG', 'RMF', 'RMI', 'RNO', 'RNS', 'ROM', 'ROS', 'ROV', 'RSW', 'RTB', 'RTM', 'RUN', 'RVN', 'SAN', 'SAO', 'SAP', 'SAW', 'SBZ', 'SCL', 'SCN', 'SCQ', 'SDQ', 'SDR', 'SEA', 'SEL', 'SEZ', 'SFJ', 'SFO', 'SGN', 'SHJ', 'SID', 'SIN', 'SJC', 'SJO', 'SJU', 'SKB', 'SKG', 'SLA', 'SLL', 'SMI', 'SMO', 'SMR', 'SNN', 'SNU', 'SOC', 'SOF', 'SOU', 'SPC', 'SPS', 'SPU', 'SRE', 'SRN', 'SRQ', 'SSA', 'SSH', 'STN', 'STO', 'STR', 'SUF', 'SVD', 'SVO', 'SVQ', 'SXB', 'SXF', 'SXM', 'SYD', 'SYX', 'SYZ', 'SZF', 'SZG', 'TAB', 'TAS', 'TBS', 'TDX', 'TER', 'TFN', 'TFS', 'TGD', 'TGG', 'TGU', 'TGZ', 'THR', 'TIA', 'TIV', 'TJA', 'TLL', 'TLS', 'TLV', 'TMP', 'TMU', 'TNG', 'TNO', 'TNR', 'TPA', 'TPE', 'TPS', 'TRN', 'TRS', 'TRV', 'TSF', 'TUN', 'TXL', 'TYO', 'TZX', 'UDR', 'UIO', 'ULN', 'UME', 'URC', 'USH', 'USM', 'UST', 'UVF', 'UWE', 'VAR', 'VCE', 'VDE', 'VFA', 'VIE', 'VLC', 'VNO', 'VOL', 'VRA', 'VRN', 'VTE', 'VVI', 'VXE', 'WAW', 'WDH', 'WER', 'WLG', 'WRO', 'XMM', 'XQP', 'XRY', 'XXP', 'YBA', 'YHZ', 'YOW', 'YQB', 'YQL', 'YTO', 'YUL', 'YVR', 'YYC', 'YYF', 'YYJ', 'YYZ', 'ZAD', 'ZAG', 'ZAL', 'ZCO', 'ZGA', 'ZMG', 'ZMR', 'ZNO', 'ZNQ', 'ZNV', 'ZNZ', 'ZOY', 'ZPM', 'ZQF', 'ZRH', 'ZTH')
// tslint:enable max-line-length


export const INTERNATIONAL_IATA_CODES: Array<IataCodeModel> = [
	{
		code: 'MUB',
		regionId: '',
		countryId: 'GT11-BW',
		cityId: 'BT09-44520'
	},
	{
		code: 'FRU',
		regionId: '',
		countryId: 'GT11-KG',
		cityId: 'BT09-28205'
	},
	{
		code: 'NGO',
		regionId: '',
		countryId: 'GT11-JP',
		cityId: 'BT09-55561'
	},
	{
		code: 'SEZ',
		regionId: 'BT10-224',
		countryId: 'GT11-SC',
		cityId: 'BT09-45446'
	},
	{
		code: 'DWC',
		regionId: 'BT10-209:BT10-210:BT10-211:BT10-212:BT10-213:BT10-214:BT10-217',
		countryId: 'GT11-AE',
		cityId: 'BT09-56556'
	},
	{
		code: 'SCN',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-12673'
	},
	{
		code: 'BUY',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-10675'
	},
	{
		code: 'OSS',
		regionId: '',
		countryId: 'GT11-KG',
		cityId: 'BT09-53002'
	},
	{
		code: 'LYS',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-18045'
	},
	{
		code: 'HRG',
		regionId: 'BT10-43:BT10-44:BT10-46',
		countryId: 'GT11-EG',
		cityId: 'BT09-15280'
	},
	{
		code: 'AYT',
		regionId: 'BT10-35',
		countryId: 'GT11-TR',
		cityId: 'BT09-26660'
	},
	{
		code: 'PEK',
		regionId: 'BT10-263',
		countryId: 'GT11-CN',
		cityId: 'BT09-11802'
	},
	{
		code: 'EAS',
		regionId: '',
		countryId: 'GT11-ES',
		cityId: 'BT09-15539'
	},
	{
		code: 'TFS',
		regionId: 'BT10-7:BT10-10',
		countryId: 'GT11-ES',
		cityId: 'BT09-58045'
	},
	{
		code: 'PDL',
		regionId: 'BT10-33',
		countryId: 'GT11-PT',
		cityId: 'BT09-25763'
	},
	{
		code: 'GND',
		regionId: 'BT10-362',
		countryId: 'GT11-GD',
		cityId: 'BT09-36987'
	},
	{
		code: 'AOK',
		regionId: 'BT10-72',
		countryId: 'GT11-GR',
		cityId: 'BT09-21458'
	},
	{
		code: 'MHG',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-13322'
	},
	{
		code: 'AUS',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27736'
	},
	{
		code: 'ORY',
		regionId: 'BT10-161:BT10-162',
		countryId: 'GT11-FR',
		cityId: 'BT09-17727'
	},
	{
		code: 'ROV',
		regionId: '',
		countryId: 'GT11-RU',
		cityId: 'BT09-26133'
	},
	{
		code: 'PFO',
		regionId: 'BT10-89',
		countryId: 'GT11-CY',
		cityId: 'BT09-11816'
	},
	{
		code: 'ARN',
		regionId: 'BT10-188',
		countryId: 'GT11-SE',
		cityId: 'BT09-26192'
	},
	{
		code: 'CUZ',
		regionId: '',
		countryId: 'GT11-PE',
		cityId: 'BT09-29413'
	},
	{
		code: 'ISB',
		regionId: '',
		countryId: 'GT11-PK',
		cityId: 'BT09-28141'
	},
	{
		code: 'CAG',
		regionId: 'BT10-112',
		countryId: 'GT11-IT',
		cityId: 'BT09-23855'
	},
	{
		code: 'YQL',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11284'
	},
	{
		code: 'VOL',
		regionId: 'BT10-54',
		countryId: 'GT11-GR',
		cityId: 'BT09-21235'
	},
	{
		code: 'NCL',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-19944'
	},
	{
		code: 'BCN',
		regionId: 'BT10-12:BT10-13:BT10-22',
		countryId: 'GT11-ES',
		cityId: 'BT09-16475'
	},
	{
		code: 'FLL',
		regionId: 'BT10-281',
		countryId: 'GT11-US',
		cityId: 'BT09-27062'
	},
	{
		code: 'LAS',
		regionId: 'BT10-284',
		countryId: 'GT11-US',
		cityId: 'BT09-27447'
	},
	{
		code: 'LIR',
		regionId: 'BT10-375',
		countryId: 'GT11-CR',
		cityId: 'BT09-52151'
	},
	{
		code: 'BWE',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-14541'
	},
	{
		code: 'BJR',
		regionId: '',
		countryId: 'GT11-ET',
		cityId: 'BT09-38487'
	},
	{
		code: 'PSA',
		regionId: 'BT10-120',
		countryId: 'GT11-IT',
		cityId: 'BT09-22971'
	},
	{
		code: 'DBV',
		regionId: 'BT10-102:BT10-106:BT10-817',
		countryId: 'GT11-HR',
		cityId: 'BT09-21872'
	},
	{
		code: 'CAS',
		regionId: 'BT10-95:BT10-96',
		countryId: 'GT11-MA',
		cityId: 'BT09-24534'
	},
	{
		code: 'SNU',
		regionId: 'BT10-347:BT10-348',
		countryId: 'GT11-CU',
		cityId: 'BT09-26917'
	},
	{
		code: 'BOM',
		regionId: '',
		countryId: 'GT11-IN',
		cityId: 'BT09-38745'
	},
	{
		code: 'MLA',
		regionId: 'BT10-130:BT10-131',
		countryId: 'GT11-MT',
		cityId: 'BT09-29026'
	},
	{
		code: 'SGN',
		regionId: 'BT10-256',
		countryId: 'GT11-VN',
		cityId: 'BT09-27858'
	},
	{
		code: 'ALY',
		regionId: '',
		countryId: 'GT11-EG',
		cityId: 'BT09-15279'
	},
	{
		code: 'NSI',
		regionId: '',
		countryId: 'GT11-CM',
		cityId: 'BT09-28173'
	},
	{
		code: 'CTG',
		regionId: 'BT10-386',
		countryId: 'GT11-CO',
		cityId: 'BT09-42435'
	},
	{
		code: 'MSQ',
		regionId: '',
		countryId: 'GT11-BY',
		cityId: 'BT09-28188'
	},
	{
		code: 'BPN',
		regionId: '',
		countryId: 'GT11-ID',
		cityId: 'BT09-29553'
	},
	{
		code: 'TRS',
		regionId: '',
		countryId: 'GT11-IT',
		cityId: 'BT09-22455'
	},
	{
		code: 'ACE',
		regionId: 'BT10-8',
		countryId: 'GT11-ES',
		cityId: 'BT09-28923'
	},
	{
		code: 'KAJ',
		regionId: '',
		countryId: 'GT11-FI',
		cityId: 'BT09-28729'
	},
	{
		code: 'CGK',
		regionId: '',
		countryId: 'GT11-ID',
		cityId: 'BT09-22028'
	},
	{
		code: 'ULN',
		regionId: '',
		countryId: 'GT11-MN',
		cityId: 'BT09-28154'
	},
	{
		code: 'SKG',
		regionId: 'BT10-50:BT10-52:BT10-53',
		countryId: 'GT11-GR',
		cityId: 'BT09-21259'
	},
	{
		code: 'ROS',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-29234'
	},
	{
		code: 'OXB',
		regionId: '',
		countryId: 'GT11-GW',
		cityId: 'BT09-28163'
	},
	{
		code: 'OGG',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27197'
	},
	{
		code: 'POZ',
		regionId: '',
		countryId: 'GT11-PL',
		cityId: 'BT09-25473'
	},
	{
		code: 'HOG',
		regionId: 'BT10-348:BT10-349',
		countryId: 'GT11-CU',
		cityId: 'BT09-42475'
	},
	{
		code: 'KTM',
		regionId: '',
		countryId: 'GT11-NP',
		cityId: 'BT09-28208'
	},
	{
		code: 'BON',
		regionId: 'BT10-1015',
		countryId: 'GT11-AN',
		cityId: 'BT09-46352'
	},
	{
		code: 'CPH',
		regionId: 'BT10-187',
		countryId: 'GT11-DK',
		cityId: 'BT09-15154'
	},
	{
		code: 'OSL',
		regionId: 'BT10-189',
		countryId: 'GT11-NO',
		cityId: 'BT09-25241'
	},
	{
		code: 'JNP',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26859'
	},
	{
		code: 'SEA',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27821'
	},
	{
		code: 'NAS',
		regionId: 'BT10-357',
		countryId: 'GT11-BS',
		cityId: 'BT09-28304'
	},
	{
		code: 'AJA',
		regionId: 'BT10-163',
		countryId: 'GT11-FR',
		cityId: 'BT09-19278'
	},
	{
		code: 'MRS',
		regionId: 'BT10-166',
		countryId: 'GT11-FR',
		cityId: 'BT09-18000'
	},
	{
		code: 'ATL',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27158'
	},
	{
		code: 'TXL',
		regionId: 'BT10-432:BT10-438',
		countryId: 'GT11-DE',
		cityId: 'BT09-14643'
	},
	{
		code: 'BKK',
		regionId: 'BT10-228:BT10-230:BT10-231:BT10-232:BT10-233:BT10-236:BT10-237',
		countryId: 'GT11-TH',
		cityId: 'BT09-26491'
	},
	{
		code: 'TZX',
		regionId: '',
		countryId: 'GT11-TR',
		cityId: 'BT09-29066'
	},
	{
		code: 'PVK',
		regionId: 'BT10-56:BT10-63',
		countryId: 'GT11-GR',
		cityId: 'BT09-21304'
	},
	{
		code: 'LIS',
		regionId: 'BT10-19:BT10-24:BT10-28:BT10-31',
		countryId: 'GT11-PT',
		cityId: 'BT09-25846'
	},
	{
		code: 'RIX',
		regionId: 'BT10-200',
		countryId: 'GT11-LV',
		cityId: 'BT09-24476'
	},
	{
		code: 'DXB',
		regionId: 'BT10-209:BT10-210:BT10-211:BT10-212:BT10-213:BT10-214:BT10-215:BT10-216:BT10-217',
		countryId: 'GT11-AE',
		cityId: 'BT09-10029'
	},
	{
		code: 'FTE',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-41324'
	},
	{
		code: 'RAR',
		regionId: '',
		countryId: 'GT11-CK',
		cityId: 'BT09-45213'
	},
	{
		code: 'ADZ',
		regionId: 'BT10-386',
		countryId: 'GT11-CO',
		cityId: 'BT09-52077'
	},
	{
		code: 'SPU',
		regionId: 'BT10-100:BT10-101:BT10-102:BT10-103:BT10-105:BT10-106',
		countryId: 'GT11-HR',
		cityId: 'BT09-21789'
	},
	{
		code: 'WAW',
		regionId: 'BT10-202',
		countryId: 'GT11-PL',
		cityId: 'BT09-25403'
	},
	{
		code: 'NAT',
		regionId: 'BT10-381',
		countryId: 'GT11-BR',
		cityId: 'BT09-38918'
	},
	{
		code: 'BSB',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-41342'
	},
	{
		code: 'VRN',
		regionId: 'BT10-117:BT10-121:BT10-123',
		countryId: 'GT11-IT',
		cityId: 'BT09-22407'
	},
	{
		code: 'BSH',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-31631'
	},
	{
		code: 'DTW',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27382'
	},
	{
		code: 'BZC',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-28068'
	},
	{
		code: 'RNS',
		regionId: 'BT10-169',
		countryId: 'GT11-FR',
		cityId: 'BT09-17575'
	},
	{
		code: 'IKT',
		regionId: '',
		countryId: 'GT11-RU',
		cityId: 'BT09-39368'
	},
	{
		code: 'ABJ',
		regionId: '',
		countryId: 'GT11-CI',
		cityId: 'BT09-43381'
	},
	{
		code: 'KLX',
		regionId: 'BT10-57',
		countryId: 'GT11-GR',
		cityId: 'BT09-21479'
	},
	{
		code: 'MAD',
		regionId: 'BT10-20:BT10-23',
		countryId: 'GT11-ES',
		cityId: 'BT09-15902'
	},
	{
		code: 'WLG',
		regionId: '',
		countryId: 'GT11-NZ',
		cityId: 'BT09-25321'
	},
	{
		code: 'AJR',
		regionId: '',
		countryId: 'GT11-SE',
		cityId: 'BT09-28849'
	},
	{
		code: 'AAH',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-14955'
	},
	{
		code: 'RSW',
		regionId: 'BT10-281:BT10-300',
		countryId: 'GT11-US',
		cityId: 'BT09-27063'
	},
	{
		code: 'CND',
		regionId: 'BT10-208',
		countryId: 'GT11-RO',
		cityId: 'BT09-26106'
	},
	{
		code: 'USM',
		regionId: 'BT10-228:BT10-230:BT10-231:BT10-237',
		countryId: 'GT11-TH',
		cityId: 'BT09-29431'
	},
	{
		code: 'LXR',
		regionId: 'BT10-44:BT10-46:BT10-49:BT10-1003',
		countryId: 'GT11-EG',
		cityId: 'BT09-15275'
	},
	{
		code: 'CHC',
		regionId: '',
		countryId: 'GT11-NZ',
		cityId: 'BT09-25346'
	},
	{
		code: 'MHD',
		regionId: '',
		countryId: 'GT11-IR',
		cityId: 'BT09-37972'
	},
	{
		code: 'MDC',
		regionId: 'BT10-253',
		countryId: 'GT11-ID',
		cityId: 'BT09-29456'
	},
	{
		code: 'AHO',
		regionId: 'BT10-112',
		countryId: 'GT11-IT',
		cityId: 'BT09-24044'
	},
	{
		code: 'PLZ',
		regionId: '',
		countryId: 'GT11-ZA',
		cityId: 'BT09-27886'
	},
	{
		code: 'BGY',
		regionId: '',
		countryId: 'GT11-IT',
		cityId: 'BT09-23921'
	},
	{
		code: 'DEL',
		regionId: 'BT10-265',
		countryId: 'GT11-IN',
		cityId: 'BT09-28195'
	},
	{
		code: 'CXR',
		regionId: '',
		countryId: 'GT11-VN',
		cityId: 'BT09-27861'
	},
	{
		code: 'UIO',
		regionId: 'BT10-385',
		countryId: 'GT11-EC',
		cityId: 'BT09-28147'
	},
	{
		code: 'POA',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-39572'
	},
	{
		code: 'YYF',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-28643'
	},
	{
		code: 'CJC',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-29368'
	},
	{
		code: 'ARK',
		regionId: '',
		countryId: 'GT11-TZ',
		cityId: 'BT09-39264'
	},
	{
		code: 'NUE',
		regionId: 'BT10-411:BT10-426:BT10-428',
		countryId: 'GT11-DE',
		cityId: 'BT09-13021'
	},
	{
		code: 'SYX',
		regionId: '',
		countryId: 'GT11-CN',
		cityId: 'BT09-11808'
	},
	{
		code: 'CCC',
		regionId: '',
		countryId: 'GT11-CU',
		cityId: 'BT09-38268'
	},
	{
		code: 'BUF',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27553'
	},
	{
		code: 'AZS',
		regionId: 'BT10-344',
		countryId: 'GT11-DO',
		cityId: 'BT09-52296'
	},
	{
		code: 'PDP',
		regionId: '',
		countryId: 'GT11-UY',
		cityId: 'BT09-55233'
	},
	{
		code: 'SFJ',
		regionId: '',
		countryId: 'GT11-GL',
		cityId: 'BT09-28335'
	},
	{
		code: 'SNN',
		regionId: '',
		countryId: 'GT11-IE',
		cityId: 'BT09-22242'
	},
	{
		code: 'LEI',
		regionId: 'BT10-18',
		countryId: 'GT11-ES',
		cityId: 'BT09-16561'
	},
	{
		code: 'VXE',
		regionId: '',
		countryId: 'GT11-CV',
		cityId: 'BT09-51910'
	},
	{
		code: 'DYU',
		regionId: '',
		countryId: 'GT11-TJ',
		cityId: 'BT09-28127'
	},
	{
		code: 'PER',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-10612'
	},
	{
		code: 'EYW',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27082'
	},
	{
		code: 'TNG',
		regionId: '',
		countryId: 'GT11-MA',
		cityId: 'BT09-24509'
	},
	{
		code: 'CWL',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20753'
	},
	{
		code: 'TFN',
		regionId: 'BT10-7:BT10-10',
		countryId: 'GT11-ES',
		cityId: 'BT09-15528'
	},
	{
		code: 'ASU',
		regionId: '',
		countryId: 'GT11-PY',
		cityId: 'BT09-28312'
	},
	{
		code: 'CGN',
		regionId: 'BT10-734:BT10-737',
		countryId: 'GT11-DE',
		cityId: 'BT09-13559'
	},
	{
		code: 'PUJ',
		regionId: 'BT10-344:BT10-345:BT10-346:BT10-900',
		countryId: 'GT11-DO',
		cityId: 'BT09-15230'
	},
	{
		code: 'HAV',
		regionId: 'BT10-347:BT10-348:BT10-349:BT10-350',
		countryId: 'GT11-CU',
		cityId: 'BT09-28313'
	},
	{
		code: 'EWR',
		regionId: 'BT10-285:BT10-311',
		countryId: 'GT11-US',
		cityId: 'BT09-27573'
	},
	{
		code: 'TMU',
		regionId: 'BT10-375',
		countryId: 'GT11-CR',
		cityId: 'BT09-44737'
	},
	{
		code: 'MCO',
		regionId: 'BT10-281',
		countryId: 'GT11-US',
		cityId: 'BT09-27114'
	},
	{
		code: 'RVN',
		regionId: '',
		countryId: 'GT11-FI',
		cityId: 'BT09-16836'
	},
	{
		code: 'PXO',
		regionId: 'BT10-32',
		countryId: 'GT11-PT',
		cityId: 'BT09-29036'
	},
	{
		code: 'DDI',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-50892'
	},
	{
		code: 'OTP',
		regionId: 'BT10-208',
		countryId: 'GT11-RO',
		cityId: 'BT09-26111'
	},
	{
		code: 'GRX',
		regionId: 'BT10-18',
		countryId: 'GT11-ES',
		cityId: 'BT09-16104'
	},
	{
		code: 'SXM',
		regionId: 'BT10-364:BT10-365',
		countryId: 'GT11-SX',
		cityId: 'BT09-46336'
	},
	{
		code: 'FDH',
		regionId: 'BT10-409',
		countryId: 'GT11-DE',
		cityId: 'BT09-14143'
	},
	{
		code: 'URC',
		regionId: '',
		countryId: 'GT11-CN',
		cityId: 'BT09-37615'
	},
	{
		code: 'LFW',
		regionId: '',
		countryId: 'GT11-TG',
		cityId: 'BT09-28171'
	},
	{
		code: 'GRO',
		regionId: 'BT10-12',
		countryId: 'GT11-ES',
		cityId: 'BT09-16112'
	},
	{
		code: 'CTU',
		regionId: '',
		countryId: 'GT11-CN',
		cityId: 'BT09-11798'
	},
	{
		code: 'ALG',
		regionId: '',
		countryId: 'GT11-DZ',
		cityId: 'BT09-28661'
	},
	{
		code: 'ADD',
		regionId: '',
		countryId: 'GT11-ET',
		cityId: 'BT09-28137'
	},
	{
		code: 'VFA',
		regionId: 'BT10-787',
		countryId: 'GT11-ZM',
		cityId: 'BT09-39107'
	},
	{
		code: 'TBS',
		regionId: '',
		countryId: 'GT11-GE',
		cityId: 'BT09-28193'
	},
	{
		code: 'IST',
		regionId: 'BT10-39',
		countryId: 'GT11-TR',
		cityId: 'BT09-26624'
	},
	{
		code: 'SCL',
		regionId: 'BT10-383',
		countryId: 'GT11-CL',
		cityId: 'BT09-38958'
	},
	{
		code: 'ADA',
		regionId: 'BT10-41',
		countryId: 'GT11-TR',
		cityId: 'BT09-26668'
	},
	{
		code: 'GVA',
		regionId: 'BT10-150',
		countryId: 'GT11-CH',
		cityId: 'BT09-11613'
	},
	{
		code: 'HEL',
		regionId: 'BT10-190',
		countryId: 'GT11-FI',
		cityId: 'BT09-16873'
	},
	{
		code: 'FOR',
		regionId: 'BT10-381',
		countryId: 'GT11-BR',
		cityId: 'BT09-38859'
	},
	{
		code: 'GPA',
		regionId: 'BT10-57',
		countryId: 'GT11-GR',
		cityId: 'BT09-28984'
	},
	{
		code: 'DEN',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26984'
	},
	{
		code: 'ZQF',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-12303'
	},
	{
		code: 'SFO',
		regionId: 'BT10-282',
		countryId: 'GT11-US',
		cityId: 'BT09-26907'
	},
	{
		code: 'NRN',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-12161'
	},
	{
		code: 'FUE',
		regionId: 'BT10-6',
		countryId: 'GT11-ES',
		cityId: 'BT09-28920'
	},
	{
		code: 'COS',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26983'
	},
	{
		code: 'TSF',
		regionId: 'BT10-123',
		countryId: 'GT11-IT',
		cityId: 'BT09-22459'
	},
	{
		code: 'LNZ',
		regionId: '',
		countryId: 'GT11-AT',
		cityId: 'BT09-10322'
	},
	{
		code: 'NAN',
		regionId: '',
		countryId: 'GT11-FJ',
		cityId: 'BT09-16890'
	},
	{
		code: 'BRE',
		regionId: 'BT10-757',
		countryId: 'GT11-DE',
		cityId: 'BT09-14532'
	},
	{
		code: 'HER',
		regionId: 'BT10-59',
		countryId: 'GT11-GR',
		cityId: 'BT09-21485'
	},
	{
		code: 'GRJ',
		regionId: '',
		countryId: 'GT11-ZA',
		cityId: 'BT09-27926'
	},
	{
		code: 'ITO',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27194'
	},
	{
		code: 'BKI',
		regionId: 'BT10-238:BT10-245',
		countryId: 'GT11-MY',
		cityId: 'BT09-24665'
	},
	{
		code: 'MDZ',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-39391'
	},
	{
		code: 'BDS',
		regionId: 'BT10-126:BT10-129',
		countryId: 'GT11-IT',
		cityId: 'BT09-23870'
	},
	{
		code: 'SVO',
		regionId: '',
		countryId: 'GT11-RU',
		cityId: 'BT09-26136'
	},
	{
		code: 'HHQ',
		regionId: 'BT10-233',
		countryId: 'GT11-TH',
		cityId: 'BT09-26515'
	},
	{
		code: 'LRM',
		regionId: 'BT10-344:BT10-345:BT10-346',
		countryId: 'GT11-DO',
		cityId: 'BT09-15233'
	},
	{
		code: 'TIV',
		regionId: 'BT10-817',
		countryId: 'GT11-ME',
		cityId: 'BT09-28442'
	},
	{
		code: 'FPO',
		regionId: 'BT10-357',
		countryId: 'GT11-US',
		cityId: 'BT09-27289'
	},
	{
		code: 'TER',
		regionId: 'BT10-33',
		countryId: 'GT11-PT',
		cityId: 'BT09-54083'
	},
	{
		code: 'CLO',
		regionId: '',
		countryId: 'GT11-CO',
		cityId: 'BT09-44828'
	},
	{
		code: 'REP',
		regionId: 'BT10-257',
		countryId: 'GT11-KH',
		cityId: 'BT09-38780'
	},
	{
		code: 'LDY',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20081'
	},
	{
		code: 'SVQ',
		regionId: 'BT10-18:BT10-19',
		countryId: 'GT11-ES',
		cityId: 'BT09-15487'
	},
	{
		code: 'TNR',
		regionId: '',
		countryId: 'GT11-MG',
		cityId: 'BT09-28202'
	},
	{
		code: 'UST',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27131'
	},
	{
		code: 'SHJ',
		regionId: 'BT10-210',
		countryId: 'GT11-AE',
		cityId: 'BT09-10032'
	},
	{
		code: 'YYC',
		regionId: 'BT10-333',
		countryId: 'GT11-CA',
		cityId: 'BT09-11335'
	},
	{
		code: 'DLM',
		regionId: 'BT10-37',
		countryId: 'GT11-TR',
		cityId: 'BT09-26676'
	},
	{
		code: 'CUR',
		regionId: 'BT10-1015:BT10-1016',
		countryId: 'GT11-CW',
		cityId: 'BT09-10044'
	},
	{
		code: 'DUS',
		regionId: 'BT10-736',
		countryId: 'GT11-DE',
		cityId: 'BT09-14339'
	},
	{
		code: 'LOP',
		regionId: 'BT10-249',
		countryId: 'GT11-ID',
		cityId: 'BT09-29556'
	},
	{
		code: 'CLW',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27043'
	},
	{
		code: 'KCH',
		regionId: 'BT10-244',
		countryId: 'GT11-MY',
		cityId: 'BT09-24684'
	},
	{
		code: 'ZGA',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-14083'
	},
	{
		code: 'GOT',
		regionId: 'BT10-188',
		countryId: 'GT11-SE',
		cityId: 'BT09-26309'
	},
	{
		code: 'REC',
		regionId: 'BT10-381',
		countryId: 'GT11-BR',
		cityId: 'BT09-38928'
	},
	{
		code: 'RTB',
		regionId: '',
		countryId: 'GT11-HN',
		cityId: 'BT09-38696'
	},
	{
		code: 'OVD',
		regionId: '',
		countryId: 'GT11-ES',
		cityId: 'BT09-15742'
	},
	{
		code: 'SJC',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26908'
	},
	{
		code: 'KIX',
		regionId: '',
		countryId: 'GT11-JP',
		cityId: 'BT09-44484'
	},
	{
		code: 'PVG',
		regionId: 'BT10-263',
		countryId: 'GT11-CN',
		cityId: 'BT09-11781'
	},
	{
		code: 'ORD',
		regionId: 'BT10-295',
		countryId: 'GT11-US',
		cityId: 'BT09-27224'
	},
	{
		code: 'BJL',
		regionId: 'BT10-397',
		countryId: 'GT11-GM',
		cityId: 'BT09-28144'
	},
	{
		code: 'PUY',
		regionId: 'BT10-98',
		countryId: 'GT11-HR',
		cityId: 'BT09-21803'
	},
	{
		code: 'LCY',
		regionId: 'BT10-180:BT10-182',
		countryId: 'GT11-GB',
		cityId: 'BT09-11282'
	},
	{
		code: 'LGB',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26829'
	},
	{
		code: 'GGT',
		regionId: '',
		countryId: 'GT11-BS',
		cityId: 'BT09-38465'
	},
	{
		code: 'TAB',
		regionId: 'BT10-359',
		countryId: 'GT11-TT',
		cityId: 'BT09-54447'
	},
	{
		code: 'MCM',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-34315'
	},
	{
		code: 'PGD',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-37946'
	},
	{
		code: 'LTN',
		regionId: 'BT10-180:BT10-182',
		countryId: 'GT11-GB',
		cityId: 'BT09-11282'
	},
	{
		code: 'YVR',
		regionId: 'BT10-334',
		countryId: 'GT11-CA',
		cityId: 'BT09-11205'
	},
	{
		code: 'TUN',
		regionId: 'BT10-91:BT10-92:BT10-94',
		countryId: 'GT11-TN',
		cityId: 'BT09-26562'
	},
	{
		code: 'MJT',
		regionId: 'BT10-68:BT10-69',
		countryId: 'GT11-GR',
		cityId: 'BT09-28983'
	},
	{
		code: 'DJE',
		regionId: 'BT10-93:BT10-94',
		countryId: 'GT11-TN',
		cityId: 'BT09-28696'
	},
	{
		code: 'RUN',
		regionId: 'BT10-227',
		countryId: 'GT11-FR',
		cityId: 'BT09-17465'
	},
	{
		code: 'BOB',
		regionId: '',
		countryId: 'GT11-PF',
		cityId: 'BT09-39331'
	},
	{
		code: 'SXF',
		regionId: 'BT10-432',
		countryId: 'GT11-DE',
		cityId: 'BT09-14643'
	},
	{
		code: 'GRZ',
		regionId: 'BT10-142',
		countryId: 'GT11-AT',
		cityId: 'BT09-45431'
	},
	{
		code: 'DTM',
		regionId: 'BT10-503',
		countryId: 'GT11-DE',
		cityId: 'BT09-14364'
	},
	{
		code: 'PEN',
		regionId: '',
		countryId: 'GT11-MY',
		cityId: 'BT09-29492'
	},
	{
		code: 'IFN',
		regionId: '',
		countryId: 'GT11-IR',
		cityId: 'BT09-44717'
	},
	{
		code: 'DRS',
		regionId: 'BT10-523:BT10-530:BT10-531:BT10-752',
		countryId: 'GT11-DE',
		cityId: 'BT09-14354'
	},
	{
		code: 'SRE',
		regionId: '',
		countryId: 'GT11-BO',
		cityId: 'BT09-28096'
	},
	{
		code: 'FLN',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-40087'
	},
	{
		code: 'KMG',
		regionId: '',
		countryId: 'GT11-CN',
		cityId: 'BT09-11788'
	},
	{
		code: 'TMP',
		regionId: '',
		countryId: 'GT11-FI',
		cityId: 'BT09-16830'
	},
	{
		code: 'MGA',
		regionId: '',
		countryId: 'GT11-NI',
		cityId: 'BT09-28156'
	},
	{
		code: 'FIH',
		regionId: '',
		countryId: 'GT11-CD',
		cityId: 'BT09-28169'
	},
	{
		code: 'PIE',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27133'
	},
	{
		code: 'SUF',
		regionId: 'BT10-127',
		countryId: 'GT11-IT',
		cityId: 'BT09-23100'
	},
	{
		code: 'TPS',
		regionId: '',
		countryId: 'GT11-IT',
		cityId: 'BT09-22470'
	},
	{
		code: 'APF',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27102'
	},
	{
		code: 'CNS',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-10671'
	},
	{
		code: 'DAD',
		regionId: 'BT10-256',
		countryId: 'GT11-VN',
		cityId: 'BT09-29444'
	},
	{
		code: 'BAQ',
		regionId: '',
		countryId: 'GT11-CO',
		cityId: 'BT09-38399'
	},
	{
		code: 'IGU',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-38861'
	},
	{
		code: 'KYL',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27081'
	},
	{
		code: 'JSI',
		regionId: 'BT10-54:BT10-67',
		countryId: 'GT11-GR',
		cityId: 'BT09-21272'
	},
	{
		code: 'LUQ',
		regionId: '',
		countryId: 'GT11-ES',
		cityId: 'BT09-37319'
	},
	{
		code: 'BRC',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-36981'
	},
	{
		code: 'NDR',
		regionId: 'BT10-97',
		countryId: 'GT11-MA',
		cityId: 'BT09-36182'
	},
	{
		code: 'AEP',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-27984'
	},
	{
		code: 'GZT',
		regionId: '',
		countryId: 'GT11-TR',
		cityId: 'BT09-26631'
	},
	{
		code: 'SAW',
		regionId: 'BT10-39',
		countryId: 'GT11-TR',
		cityId: 'BT09-26624'
	},
	{
		code: 'MEL',
		regionId: 'BT10-897',
		countryId: 'GT11-AU',
		cityId: 'BT09-10625'
	},
	{
		code: 'PDX',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27650'
	},
	{
		code: 'VAR',
		regionId: 'BT10-109:BT10-110:BT10-208',
		countryId: 'GT11-BG',
		cityId: 'BT09-11046'
	},
	{
		code: 'TGZ',
		regionId: '',
		countryId: 'GT11-MX',
		cityId: 'BT09-24579'
	},
	{
		code: 'JOG',
		regionId: '',
		countryId: 'GT11-ID',
		cityId: 'BT09-29538'
	},
	{
		code: 'SZF',
		regionId: '',
		countryId: 'GT11-TR',
		cityId: 'BT09-29655'
	},
	{
		code: 'CAI',
		regionId: 'BT10-47',
		countryId: 'GT11-EG',
		cityId: 'BT09-15276'
	},
	{
		code: 'BJV',
		regionId: 'BT10-36:BT10-38',
		countryId: 'GT11-TR',
		cityId: 'BT09-26654'
	},
	{
		code: 'MAA',
		regionId: '',
		countryId: 'GT11-IN',
		cityId: 'BT09-38343'
	},
	{
		code: 'ORE',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-17753'
	},
	{
		code: 'SZG',
		regionId: 'BT10-139:BT10-140:BT10-142:BT10-716',
		countryId: 'GT11-AT',
		cityId: 'BT09-10217'
	},
	{
		code: 'TPE',
		regionId: 'BT10-260',
		countryId: 'GT11-TW',
		cityId: 'BT09-26686'
	},
	{
		code: 'MFM',
		regionId: 'BT10-263',
		countryId: 'GT11-CN',
		cityId: 'BT09-30065'
	},
	{
		code: 'ARI',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-29366'
	},
	{
		code: 'LPB',
		regionId: '',
		countryId: 'GT11-BO',
		cityId: 'BT09-41110'
	},
	{
		code: 'ASR',
		regionId: 'BT10-40',
		countryId: 'GT11-TR',
		cityId: 'BT09-29050'
	},
	{
		code: 'MDE',
		regionId: '',
		countryId: 'GT11-CO',
		cityId: 'BT09-44829'
	},
	{
		code: 'GOI',
		regionId: 'BT10-265',
		countryId: 'GT11-IN',
		cityId: 'BT09-52645'
	},
	{
		code: 'LPL',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20113'
	},
	{
		code: 'ANU',
		regionId: 'BT10-355',
		countryId: 'GT11-AG',
		cityId: 'BT09-28308'
	},
	{
		code: 'MJV',
		regionId: 'BT10-16',
		countryId: 'GT11-ES',
		cityId: 'BT09-15804'
	},
	{
		code: 'CUN',
		regionId: 'BT10-371:BT10-907',
		countryId: 'GT11-MX',
		cityId: 'BT09-24641'
	},
	{
		code: 'BGO',
		regionId: '',
		countryId: 'GT11-NO',
		cityId: 'BT09-25294'
	},
	{
		code: 'LIM',
		regionId: 'BT10-384',
		countryId: 'GT11-PE',
		cityId: 'BT09-39100'
	},
	{
		code: 'BFS',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20913'
	},
	{
		code: 'IXB',
		regionId: '',
		countryId: 'GT11-IN',
		cityId: 'BT09-38074'
	},
	{
		code: 'CWB',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-43281'
	},
	{
		code: 'NBO',
		regionId: '',
		countryId: 'GT11-KE',
		cityId: 'BT09-28167'
	},
	{
		code: 'SMO',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26922'
	},
	{
		code: 'AGT',
		regionId: '',
		countryId: 'GT11-PY',
		cityId: 'BT09-38430'
	},
	{
		code: 'RJK',
		regionId: 'BT10-98:BT10-99:BT10-106:BT10-699:BT10-763',
		countryId: 'GT11-HR',
		cityId: 'BT09-21799'
	},
	{
		code: 'PTY',
		regionId: 'BT10-8:BT10-377',
		countryId: 'GT11-PA',
		cityId: 'BT09-28302'
	},
	{
		code: 'BAX',
		regionId: '',
		countryId: 'GT11-RU',
		cityId: 'BT09-42503'
	},
	{
		code: 'ISM',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27083'
	},
	{
		code: 'HDF',
		regionId: 'BT10-468',
		countryId: 'GT11-DE',
		cityId: 'BT09-28706'
	},
	{
		code: 'JER',
		regionId: 'BT10-184',
		countryId: 'GT11-GB',
		cityId: 'BT09-54512'
	},
	{
		code: 'ECN',
		regionId: 'BT10-90',
		countryId: 'GT11-CY',
		cityId: 'BT09-11819'
	},
	{
		code: 'SVD',
		regionId: '',
		countryId: 'GT11-VC',
		cityId: 'BT09-44363'
	},
	{
		code: 'ORB',
		regionId: '',
		countryId: 'GT11-SE',
		cityId: 'BT09-26235'
	},
	{
		code: 'CNX',
		regionId: 'BT10-236',
		countryId: 'GT11-TH',
		cityId: 'BT09-26520'
	},
	{
		code: 'VVI',
		regionId: '',
		countryId: 'GT11-BO',
		cityId: 'BT09-42578'
	},
	{
		code: 'BUD',
		regionId: 'BT10-205',
		countryId: 'GT11-HU',
		cityId: 'BT09-21998'
	},
	{
		code: 'HAM',
		regionId: 'BT10-447',
		countryId: 'GT11-DE',
		cityId: 'BT09-13917'
	},
	{
		code: 'DME',
		regionId: 'BT10-194',
		countryId: 'GT11-RU',
		cityId: 'BT09-26136'
	},
	{
		code: 'BAH',
		regionId: '',
		countryId: 'GT11-BH',
		cityId: 'BT09-29133'
	},
	{
		code: 'CFU',
		regionId: 'BT10-62:BT10-88',
		countryId: 'GT11-GR',
		cityId: 'BT09-21444'
	},
	{
		code: 'FRA',
		regionId: 'BT10-738:BT10-744',
		countryId: 'GT11-DE',
		cityId: 'BT09-14170'
	},
	{
		code: 'CGB',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-29305'
	},
	{
		code: 'SDR',
		regionId: '',
		countryId: 'GT11-ES',
		cityId: 'BT09-15516'
	},
	{
		code: 'ZNV',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-13567'
	},
	{
		code: 'BHX',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20885'
	},
	{
		code: 'DFW',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27740'
	},
	{
		code: 'DUR',
		regionId: 'BT10-693',
		countryId: 'GT11-ZA',
		cityId: 'BT09-27930'
	},
	{
		code: 'CPT',
		regionId: 'BT10-393',
		countryId: 'GT11-ZA',
		cityId: 'BT09-27935'
	},
	{
		code: 'PQC',
		regionId: 'BT10-256',
		countryId: 'GT11-VN',
		cityId: 'BT09-27859'
	},
	{
		code: 'CEB',
		regionId: 'BT10-255',
		countryId: 'GT11-PH',
		cityId: 'BT09-39154'
	},
	{
		code: 'NDJ',
		regionId: '',
		countryId: 'GT11-TD',
		cityId: 'BT09-28176'
	},
	{
		code: 'BTS',
		regionId: 'BT10-204',
		countryId: 'GT11-SK',
		cityId: 'BT09-26477'
	},
	{
		code: 'KGL',
		regionId: '',
		countryId: 'GT11-RW',
		cityId: 'BT09-28299'
	},
	{
		code: 'MCT',
		regionId: 'BT10-217',
		countryId: 'GT11-OM',
		cityId: 'BT09-25367'
	},
	{
		code: 'TIA',
		regionId: '',
		countryId: 'GT11-AL',
		cityId: 'BT09-28135'
	},
	{
		code: 'ABZ',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-21069'
	},
	{
		code: 'SOU',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-19651'
	},
	{
		code: 'NQY',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-19937'
	},
	{
		code: 'TLV',
		regionId: 'BT10-221',
		countryId: 'GT11-IL',
		cityId: 'BT09-22266'
	},
	{
		code: 'ALA',
		regionId: '',
		countryId: 'GT11-KZ',
		cityId: 'BT09-45192'
	},
	{
		code: 'SCQ',
		regionId: 'BT10-21',
		countryId: 'GT11-ES',
		cityId: 'BT09-15509'
	},
	{
		code: 'GIG',
		regionId: 'BT10-381',
		countryId: 'GT11-BR',
		cityId: 'BT09-38933'
	},
	{
		code: 'BRI',
		regionId: 'BT10-126:BT10-129',
		countryId: 'GT11-IT',
		cityId: 'BT09-23945'
	},
	{
		code: 'MVD',
		regionId: 'BT10-759',
		countryId: 'GT11-UY',
		cityId: 'BT09-28145'
	},
	{
		code: 'AMM',
		regionId: 'BT10-220',
		countryId: 'GT11-JO',
		cityId: 'BT09-24369'
	},
	{
		code: 'SBZ',
		regionId: 'BT10-208',
		countryId: 'GT11-RO',
		cityId: 'BT09-26069'
	},
	{
		code: 'SRQ',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-38772'
	},
	{
		code: 'VCE',
		regionId: 'BT10-117:BT10-121:BT10-122:BT10-123',
		countryId: 'GT11-IT',
		cityId: 'BT09-22413'
	},
	{
		code: 'AGP',
		regionId: 'BT10-18:BT10-19',
		countryId: 'GT11-ES',
		cityId: 'BT09-15895'
	},
	{
		code: 'KTW',
		regionId: '',
		countryId: 'GT11-PL',
		cityId: 'BT09-25561'
	},
	{
		code: 'SMR',
		regionId: '',
		countryId: 'GT11-CO',
		cityId: 'BT09-38819'
	},
	{
		code: 'CLJ',
		regionId: '',
		countryId: 'GT11-RO',
		cityId: 'BT09-26107'
	},
	{
		code: 'DOH',
		regionId: 'BT10-218',
		countryId: 'GT11-QA',
		cityId: 'BT09-26049'
	},
	{
		code: 'JTR',
		regionId: 'BT10-82:BT10-990',
		countryId: 'GT11-GR',
		cityId: 'BT09-32530'
	},
	{
		code: 'ASW',
		regionId: 'BT10-49',
		countryId: 'GT11-EG',
		cityId: 'BT09-15274'
	},
	{
		code: 'RMF',
		regionId: 'BT10-43:BT10-44',
		countryId: 'GT11-EG',
		cityId: 'BT09-15270'
	},
	{
		code: 'ANC',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26695'
	},
	{
		code: 'AUH',
		regionId: 'BT10-209:BT10-210:BT10-211:BT10-212:BT10-213:BT10-214:BT10-215:BT10-216',
		countryId: 'GT11-AE',
		cityId: 'BT09-10038'
	},
	{
		code: 'GDN',
		regionId: 'BT10-202',
		countryId: 'GT11-PL',
		cityId: 'BT09-25586'
	},
	{
		code: 'KTT',
		regionId: 'BT10-190',
		countryId: 'GT11-FI',
		cityId: 'BT09-28733'
	},
	{
		code: 'MBA',
		regionId: 'BT10-647',
		countryId: 'GT11-KE',
		cityId: 'BT09-44628'
	},
	{
		code: 'BEG',
		regionId: '',
		countryId: 'GT11-RS',
		cityId: 'BT09-28286'
	},
	{
		code: 'SJO',
		regionId: 'BT10-375',
		countryId: 'GT11-CR',
		cityId: 'BT09-28317'
	},
	{
		code: 'SOF',
		regionId: 'BT10-111',
		countryId: 'GT11-BG',
		cityId: 'BT09-11053'
	},
	{
		code: 'BIO',
		regionId: 'BT10-21',
		countryId: 'GT11-ES',
		cityId: 'BT09-16432'
	},
	{
		code: 'CTA',
		regionId: 'BT10-113',
		countryId: 'GT11-IT',
		cityId: 'BT09-23698'
	},
	{
		code: 'OLB',
		regionId: 'BT10-112',
		countryId: 'GT11-IT',
		cityId: 'BT09-23072'
	},
	{
		code: 'LIH',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-39127'
	},
	{
		code: 'CHQ',
		regionId: 'BT10-59',
		countryId: 'GT11-GR',
		cityId: 'BT09-21442'
	},
	{
		code: 'VRA',
		regionId: 'BT10-347:BT10-348:BT10-349:BT10-350',
		countryId: 'GT11-CU',
		cityId: 'BT09-38307'
	},
	{
		code: 'SJU',
		regionId: 'BT10-353',
		countryId: 'GT11-PR',
		cityId: 'BT09-25632'
	},
	{
		code: 'ICN',
		regionId: '',
		countryId: 'GT11-KR',
		cityId: 'BT09-28198'
	},
	{
		code: 'EDO',
		regionId: '',
		countryId: 'GT11-TR',
		cityId: 'BT09-26640'
	},
	{
		code: 'AAL',
		regionId: '',
		countryId: 'GT11-DK',
		cityId: 'BT09-28814'
	},
	{
		code: 'LBV',
		regionId: '',
		countryId: 'GT11-GA',
		cityId: 'BT09-28192'
	},
	{
		code: 'SSA',
		regionId: 'BT10-381:BT10-819',
		countryId: 'GT11-BR',
		cityId: 'BT09-38938'
	},
	{
		code: 'PNA',
		regionId: '',
		countryId: 'GT11-ES',
		cityId: 'BT09-15731'
	},
	{
		code: 'RNO',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27451'
	},
	{
		code: 'DUB',
		regionId: 'BT10-186',
		countryId: 'GT11-IE',
		cityId: 'BT09-22160'
	},
	{
		code: 'VDE',
		regionId: '',
		countryId: 'GT11-ES',
		cityId: 'BT09-54337'
	},
	{
		code: 'TGD',
		regionId: '',
		countryId: 'GT11-ME',
		cityId: 'BT09-29072'
	},
	{
		code: 'PRI',
		regionId: 'BT10-224',
		countryId: 'GT11-SC',
		cityId: 'BT09-54232'
	},
	{
		code: 'WDH',
		regionId: 'BT10-395',
		countryId: 'GT11-NA',
		cityId: 'BT09-28207'
	},
	{
		code: 'UME',
		regionId: '',
		countryId: 'GT11-SE',
		cityId: 'BT09-26173'
	},
	{
		code: 'PMI',
		regionId: 'BT10-1',
		countryId: 'GT11-ES',
		cityId: 'BT09-15733'
	},
	{
		code: 'SDQ',
		regionId: 'BT10-344:BT10-345:BT10-346:BT10-900',
		countryId: 'GT11-DO',
		cityId: 'BT09-15226'
	},
	{
		code: 'PEG',
		regionId: '',
		countryId: 'GT11-IT',
		cityId: 'BT09-23007'
	},
	{
		code: 'BOG',
		regionId: 'BT10-386',
		countryId: 'GT11-CO',
		cityId: 'BT09-28134'
	},
	{
		code: 'PBM',
		regionId: '',
		countryId: 'GT11-SR',
		cityId: 'BT09-28305'
	},
	{
		code: 'LGA',
		regionId: 'BT10-285',
		countryId: 'GT11-US',
		cityId: 'BT09-27573'
	},
	{
		code: 'ALC',
		regionId: 'BT10-15:BT10-16',
		countryId: 'GT11-ES',
		cityId: 'BT09-16571'
	},
	{
		code: 'QWU',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-11993'
	},
	{
		code: 'PAS',
		regionId: '',
		countryId: 'GT11-GR',
		cityId: 'BT09-29605'
	},
	{
		code: 'YYJ',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11204'
	},
	{
		code: 'LGK',
		regionId: '',
		countryId: 'GT11-MY',
		cityId: 'BT09-30680'
	},
	{
		code: 'INN',
		regionId: 'BT10-122:BT10-135:BT10-136:BT10-137:BT10-143:BT10-921:BT10-940:BT10-951',
		countryId: 'GT11-AT',
		cityId: 'BT09-10379'
	},
	{
		code: 'FSC',
		regionId: 'BT10-163',
		countryId: 'GT11-FR',
		cityId: 'BT09-28958'
	},
	{
		code: 'ESB',
		regionId: '',
		countryId: 'GT11-TR',
		cityId: 'BT09-26662'
	},
	{
		code: 'KUA',
		regionId: 'BT10-240',
		countryId: 'GT11-MY',
		cityId: 'BT09-24679'
	},
	{
		code: 'LBD',
		regionId: '',
		countryId: 'GT11-TJ',
		cityId: 'BT09-54413'
	},
	{
		code: 'TNO',
		regionId: 'BT10-375',
		countryId: 'GT11-CR',
		cityId: 'BT09-39181'
	},
	{
		code: 'SPS',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-43557'
	},
	{
		code: 'TDX',
		regionId: 'BT10-233:BT10-237',
		countryId: 'GT11-TH',
		cityId: 'BT09-29593'
	},
	{
		code: 'VNO',
		regionId: 'BT10-201',
		countryId: 'GT11-LT',
		cityId: 'BT09-24392'
	},
	{
		code: 'PNH',
		regionId: '',
		countryId: 'GT11-KH',
		cityId: 'BT09-28300'
	},
	{
		code: 'JNB',
		regionId: 'BT10-225:BT10-392',
		countryId: 'GT11-ZA',
		cityId: 'BT09-27913'
	},
	{
		code: 'LPA',
		regionId: 'BT10-5',
		countryId: 'GT11-ES',
		cityId: 'BT09-28922'
	},
	{
		code: 'HKG',
		regionId: 'BT10-261:BT10-263',
		countryId: 'GT11-HK',
		cityId: 'BT09-21752'
	},
	{
		code: 'FCO',
		regionId: 'BT10-118',
		countryId: 'GT11-IT',
		cityId: 'BT09-22827'
	},
	{
		code: 'REU',
		regionId: '',
		countryId: 'GT11-ES',
		cityId: 'BT09-15639'
	},
	{
		code: 'RLG',
		regionId: 'BT10-465:BT10-468:BT10-469:BT10-472:BT10-517:BT10-741:BT10-747',
		countryId: 'GT11-DE',
		cityId: 'BT09-28867'
	},
	{
		code: 'ZRH',
		regionId: 'BT10-147:BT10-155:BT10-158',
		countryId: 'GT11-CH',
		cityId: 'BT09-11376'
	},
	{
		code: 'MPM',
		regionId: '',
		countryId: 'GT11-MZ',
		cityId: 'BT09-28189'
	},
	{
		code: 'JAI',
		regionId: '',
		countryId: 'GT11-IN',
		cityId: 'BT09-44640'
	},
	{
		code: 'BGR',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27283'
	},
	{
		code: 'OXF',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-19881'
	},
	{
		code: 'UVF',
		regionId: 'BT10-356',
		countryId: 'GT11-LC',
		cityId: 'BT09-39310'
	},
	{
		code: 'RAK',
		regionId: 'BT10-95:BT10-97',
		countryId: 'GT11-MA',
		cityId: 'BT09-24522'
	},
	{
		code: 'PRG',
		regionId: 'BT10-203',
		countryId: 'GT11-CZ',
		cityId: 'BT09-11871'
	},
	{
		code: 'MIA',
		regionId: 'BT10-281',
		countryId: 'GT11-US',
		cityId: 'BT09-27095'
	},
	{
		code: 'IXL',
		regionId: '',
		countryId: 'GT11-IN',
		cityId: 'BT09-45186'
	},
	{
		code: 'MRV',
		regionId: '',
		countryId: 'GT11-RU',
		cityId: 'BT09-54145'
	},
	{
		code: 'RTM',
		regionId: 'BT10-178',
		countryId: 'GT11-NL',
		cityId: 'BT09-24849'
	},
	{
		code: 'MSY',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27280'
	},
	{
		code: 'HKT',
		regionId: 'BT10-228:BT10-230:BT10-237',
		countryId: 'GT11-TH',
		cityId: 'BT09-29433'
	},
	{
		code: 'IKA',
		regionId: '',
		countryId: 'GT11-IR',
		cityId: 'BT09-28129'
	},
	{
		code: 'BIA',
		regionId: 'BT10-163',
		countryId: 'GT11-FR',
		cityId: 'BT09-19108'
	},
	{
		code: 'MAO',
		regionId: 'BT10-381',
		countryId: 'GT11-BR',
		cityId: 'BT09-38884'
	},
	{
		code: 'MXP',
		regionId: 'BT10-117:BT10-121:BT10-122:BT10-123',
		countryId: 'GT11-IT',
		cityId: 'BT09-23218'
	},
	{
		code: 'ZTH',
		regionId: 'BT10-64:BT10-65',
		countryId: 'GT11-GR',
		cityId: 'BT09-21221'
	},
	{
		code: 'DAR',
		regionId: '',
		countryId: 'GT11-TZ',
		cityId: 'BT09-44130'
	},
	{
		code: 'JSH',
		regionId: '',
		countryId: 'GT11-GR',
		cityId: 'BT09-28987'
	},
	{
		code: 'KVA',
		regionId: 'BT10-52:BT10-66',
		countryId: 'GT11-GR',
		cityId: 'BT09-21447'
	},
	{
		code: 'CMB',
		regionId: 'BT10-222',
		countryId: 'GT11-LK',
		cityId: 'BT09-28149'
	},
	{
		code: 'BBK',
		regionId: '',
		countryId: 'GT11-BW',
		cityId: 'BT09-44623'
	},
	{
		code: 'CLY',
		regionId: 'BT10-163',
		countryId: 'GT11-FR',
		cityId: 'BT09-18923'
	},
	{
		code: 'CEG',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20706'
	},
	{
		code: 'PUX',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-39499'
	},
	{
		code: 'KOA',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-54828'
	},
	{
		code: 'TAS',
		regionId: '',
		countryId: 'GT11-UZ',
		cityId: 'BT09-28200'
	},
	{
		code: 'FEZ',
		regionId: '',
		countryId: 'GT11-MA',
		cityId: 'BT09-24529'
	},
	{
		code: 'STN',
		regionId: 'BT10-180:BT10-182',
		countryId: 'GT11-GB',
		cityId: 'BT09-11282'
	},
	{
		code: 'YHZ',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11303'
	},
	{
		code: 'HOU',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27745'
	},
	{
		code: 'ZCO',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-29382'
	},
	{
		code: 'BOJ',
		regionId: 'BT10-109:BT10-110',
		countryId: 'GT11-BG',
		cityId: 'BT09-11084'
	},
	{
		code: 'SLL',
		regionId: 'BT10-217',
		countryId: 'GT11-OM',
		cityId: 'BT09-25366'
	},
	{
		code: 'SAP',
		regionId: 'BT10-378',
		countryId: 'GT11-HN',
		cityId: 'BT09-38700'
	},
	{
		code: 'EBB',
		regionId: '',
		countryId: 'GT11-UG',
		cityId: 'BT09-37127'
	},
	{
		code: 'EVN',
		regionId: '',
		countryId: 'GT11-AM',
		cityId: 'BT09-28177'
	},
	{
		code: 'LUX',
		regionId: '',
		countryId: 'GT11-LU',
		cityId: 'BT09-24430'
	},
	{
		code: 'GOA',
		regionId: 'BT10-120',
		countryId: 'GT11-IT',
		cityId: 'BT09-23454'
	},
	{
		code: 'GRU',
		regionId: '',
		countryId: 'GT11-BR',
		cityId: 'BT09-27994'
	},
	{
		code: 'BRU',
		regionId: 'BT10-177',
		countryId: 'GT11-BE',
		cityId: 'BT09-10993'
	},
	{
		code: 'YBA',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11348'
	},
	{
		code: 'NBE',
		regionId: 'BT10-91:BT10-92:BT10-94',
		countryId: 'GT11-TN',
		cityId: 'BT09-26583'
	},
	{
		code: 'MLE',
		regionId: 'BT10-223',
		countryId: 'GT11-MV',
		cityId: 'BT09-28204'
	},
	{
		code: 'PHX',
		regionId: 'BT10-288',
		countryId: 'GT11-US',
		cityId: 'BT09-26710'
	},
	{
		code: 'LIN',
		regionId: 'BT10-121',
		countryId: 'GT11-IT',
		cityId: 'BT09-23218'
	},
	{
		code: 'RBA',
		regionId: '',
		countryId: 'GT11-MA',
		cityId: 'BT09-24513'
	},
	{
		code: 'TPA',
		regionId: 'BT10-281',
		countryId: 'GT11-US',
		cityId: 'BT09-27142'
	},
	{
		code: 'HND',
		regionId: '',
		countryId: 'GT11-JP',
		cityId: 'BT09-24371'
	},
	{
		code: 'CDG',
		regionId: 'BT10-161:BT10-162',
		countryId: 'GT11-FR',
		cityId: 'BT09-17727'
	},
	{
		code: 'GZP',
		regionId: 'BT10-35',
		countryId: 'GT11-TR',
		cityId: 'BT09-57825'
	},
	{
		code: 'PTP',
		regionId: 'BT10-367',
		countryId: 'GT11-GP',
		cityId: 'BT09-42225'
	},
	{
		code: 'AMS',
		regionId: 'BT10-178',
		countryId: 'GT11-NL',
		cityId: 'BT09-25199'
	},
	{
		code: 'LJU',
		regionId: '',
		countryId: 'GT11-SI',
		cityId: 'BT09-26400'
	},
	{
		code: 'TLS',
		regionId: 'BT10-176',
		countryId: 'GT11-FR',
		cityId: 'BT09-17096'
	},
	{
		code: 'BOS',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27330'
	},
	{
		code: 'AAR',
		regionId: '',
		countryId: 'GT11-DK',
		cityId: 'BT09-28808'
	},
	{
		code: 'PSR',
		regionId: '',
		countryId: 'GT11-IT',
		cityId: 'BT09-23004'
	},
	{
		code: 'PHL',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27681'
	},
	{
		code: 'VTE',
		regionId: '',
		countryId: 'GT11-LA',
		cityId: 'BT09-28321'
	},
	{
		code: 'AQJ',
		regionId: 'BT10-220',
		countryId: 'GT11-JO',
		cityId: 'BT09-24370'
	},
	{
		code: 'ZMG',
		regionId: '',
		countryId: 'GT11-DE',
		cityId: 'BT09-13337'
	},
	{
		code: 'MRU',
		regionId: 'BT10-225',
		countryId: 'GT11-MU',
		cityId: 'BT09-32939'
	},
	{
		code: 'YUL',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11272'
	},
	{
		code: 'ATH',
		regionId: 'BT10-55:BT10-57:BT10-58:BT10-84',
		countryId: 'GT11-GR',
		cityId: 'BT09-21548'
	},
	{
		code: 'GLF',
		regionId: '',
		countryId: 'GT11-CR',
		cityId: 'BT09-44754'
	},
	{
		code: 'MDQ',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-27977'
	},
	{
		code: 'NCE',
		regionId: 'BT10-164:BT10-165:BT10-166:BT10-175',
		countryId: 'GT11-FR',
		cityId: 'BT09-17801'
	},
	{
		code: 'JMK',
		regionId: 'BT10-77:BT10-79:BT10-80:BT10-81:BT10-83:BT10-88',
		countryId: 'GT11-GR',
		cityId: 'BT09-21377'
	},
	{
		code: 'KAO',
		regionId: '',
		countryId: 'GT11-FI',
		cityId: 'BT09-16856'
	},
	{
		code: 'SAN',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26906'
	},
	{
		code: 'SOC',
		regionId: '',
		countryId: 'GT11-ID',
		cityId: 'BT09-29562'
	},
	{
		code: 'TGG',
		regionId: 'BT10-239',
		countryId: 'GT11-MY',
		cityId: 'BT09-24668'
	},
	{
		code: 'ESU',
		regionId: 'BT10-97',
		countryId: 'GT11-MA',
		cityId: 'BT09-24530'
	},
	{
		code: 'SLA',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-39615'
	},
	{
		code: 'AOI',
		regionId: 'BT10-125',
		countryId: 'GT11-IT',
		cityId: 'BT09-24027'
	},
	{
		code: 'ASB',
		regionId: '',
		countryId: 'GT11-TM',
		cityId: 'BT09-28298'
	},
	{
		code: 'EFL',
		regionId: 'BT10-64',
		countryId: 'GT11-GR',
		cityId: 'BT09-28979'
	},
	{
		code: 'PIT',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27682'
	},
	{
		code: 'AYQ',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-55420'
	},
	{
		code: 'BLQ',
		regionId: 'BT10-124',
		countryId: 'GT11-IT',
		cityId: 'BT09-23903'
	},
	{
		code: 'PUQ',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-29370'
	},
	{
		code: 'TRV',
		regionId: 'BT10-265',
		countryId: 'GT11-IN',
		cityId: 'BT09-38337'
	},
	{
		code: 'JFK',
		regionId: 'BT10-285:BT10-311',
		countryId: 'GT11-US',
		cityId: 'BT09-27573'
	},
	{
		code: 'SID',
		regionId: 'BT10-34',
		countryId: 'GT11-CV',
		cityId: 'BT09-51906'
	},
	{
		code: 'ORK',
		regionId: '',
		countryId: 'GT11-IE',
		cityId: 'BT09-22175'
	},
	{
		code: 'NTE',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-17824'
	},
	{
		code: 'ITM',
		regionId: '',
		countryId: 'GT11-JP',
		cityId: 'BT09-44484'
	},
	{
		code: 'WRO',
		regionId: 'BT10-202',
		countryId: 'GT11-PL',
		cityId: 'BT09-25393'
	},
	{
		code: 'FDF',
		regionId: 'BT10-360',
		countryId: 'GT11-MQ',
		cityId: 'BT09-36984'
	},
	{
		code: 'BRN',
		regionId: 'BT10-152',
		countryId: 'GT11-CH',
		cityId: 'BT09-11693'
	},
	{
		code: 'MDL',
		regionId: '',
		countryId: 'GT11-MM',
		cityId: 'BT09-39000'
	},
	{
		code: 'YQB',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11248'
	},
	{
		code: 'KUL',
		regionId: 'BT10-238:BT10-239:BT10-243',
		countryId: 'GT11-MY',
		cityId: 'BT09-24678'
	},
	{
		code: 'ERF',
		regionId: 'BT10-559',
		countryId: 'GT11-DE',
		cityId: 'BT09-14255'
	},
	{
		code: 'BRS',
		regionId: 'BT10-182',
		countryId: 'GT11-GB',
		cityId: 'BT09-20812'
	},
	{
		code: 'SMI',
		regionId: 'BT10-70:BT10-71:BT10-73',
		countryId: 'GT11-GR',
		cityId: 'BT09-21294'
	},
	{
		code: 'MNL',
		regionId: 'BT10-255',
		countryId: 'GT11-PH',
		cityId: 'BT09-28131'
	},
	{
		code: 'OUA',
		regionId: '',
		countryId: 'GT11-BF',
		cityId: 'BT09-28182'
	},
	{
		code: 'SXB',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-17146'
	},
	{
		code: 'CIY',
		regionId: '',
		countryId: 'GT11-IT',
		cityId: 'BT09-55559'
	},
	{
		code: 'LIL',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-18102'
	},
	{
		code: 'HNL',
		regionId: 'BT10-283',
		countryId: 'GT11-US',
		cityId: 'BT09-27195'
	},
	{
		code: 'IPW',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20237'
	},
	{
		code: 'KEF',
		regionId: '',
		countryId: 'GT11-IS',
		cityId: 'BT09-22328'
	},
	{
		code: 'RHO',
		regionId: 'BT10-60:BT10-74:BT10-75',
		countryId: 'GT11-GR',
		cityId: 'BT09-21594'
	},
	{
		code: 'IBZ',
		regionId: 'BT10-2:BT10-4',
		countryId: 'GT11-ES',
		cityId: 'BT09-16066'
	},
	{
		code: 'ZNZ',
		regionId: 'BT10-390',
		countryId: 'GT11-TZ',
		cityId: 'BT09-39287'
	},
	{
		code: 'TJA',
		regionId: '',
		countryId: 'GT11-BO',
		cityId: 'BT09-37928'
	},
	{
		code: 'SRN',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-28410'
	},
	{
		code: 'SSH',
		regionId: 'BT10-45',
		countryId: 'GT11-EG',
		cityId: 'BT09-15267'
	},
	{
		code: 'FMY',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27063'
	},
	{
		code: 'UDR',
		regionId: '',
		countryId: 'GT11-IN',
		cityId: 'BT09-38345'
	},
	{
		code: 'PCN',
		regionId: '',
		countryId: 'GT11-NZ',
		cityId: 'BT09-25355'
	},
	{
		code: 'XQP',
		regionId: '',
		countryId: 'GT11-CR',
		cityId: 'BT09-44592'
	},
	{
		code: 'SPC',
		regionId: 'BT10-9',
		countryId: 'GT11-ES',
		cityId: 'BT09-15531'
	},
	{
		code: 'VIE',
		regionId: 'BT10-132:BT10-204:BT10-205',
		countryId: 'GT11-AT',
		cityId: 'BT09-10092'
	},
	{
		code: 'BNA',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27731'
	},
	{
		code: 'PID',
		regionId: '',
		countryId: 'GT11-BS',
		cityId: 'BT09-38199'
	},
	{
		code: 'ADL',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-10687'
	},
	{
		code: 'BVC',
		regionId: 'BT10-34',
		countryId: 'GT11-CV',
		cityId: 'BT09-44109'
	},
	{
		code: 'KAT',
		regionId: '',
		countryId: 'GT11-NZ',
		cityId: 'BT09-29119'
	},
	{
		code: 'BEY',
		regionId: '',
		countryId: 'GT11-LB',
		cityId: 'BT09-24384'
	},
	{
		code: 'IND',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27262'
	},
	{
		code: 'CCU',
		regionId: '',
		countryId: 'GT11-IN',
		cityId: 'BT09-38347'
	},
	{
		code: 'BOD',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-19011'
	},
	{
		code: 'OUD',
		regionId: '',
		countryId: 'GT11-MA',
		cityId: 'BT09-24515'
	},
	{
		code: 'VLC',
		regionId: 'BT10-14:BT10-15',
		countryId: 'GT11-ES',
		cityId: 'BT09-15387'
	},
	{
		code: 'KRK',
		regionId: 'BT10-202',
		countryId: 'GT11-PL',
		cityId: 'BT09-25541'
	},
	{
		code: 'TGU',
		regionId: '',
		countryId: 'GT11-HN',
		cityId: 'BT09-28152'
	},
	{
		code: 'LED',
		regionId: 'BT10-194',
		countryId: 'GT11-RU',
		cityId: 'BT09-26131'
	},
	{
		code: 'MBJ',
		regionId: 'BT10-352',
		countryId: 'GT11-JM',
		cityId: 'BT09-38205'
	},
	{
		code: 'AGA',
		regionId: 'BT10-95:BT10-97',
		countryId: 'GT11-MA',
		cityId: 'BT09-24539'
	},
	{
		code: 'KRT',
		regionId: '',
		countryId: 'GT11-SD',
		cityId: 'BT09-28110'
	},
	{
		code: 'OPO',
		regionId: 'BT10-21:BT10-31:BT10-33',
		countryId: 'GT11-PT',
		cityId: 'BT09-25755'
	},
	{
		code: 'YOW',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11255'
	},
	{
		code: 'ADB',
		regionId: 'BT10-36:BT10-37',
		countryId: 'GT11-TR',
		cityId: 'BT09-26623'
	},
	{
		code: 'HOR',
		regionId: 'BT10-33',
		countryId: 'GT11-PT',
		cityId: 'BT09-25860'
	},
	{
		code: 'DKR',
		regionId: '',
		countryId: 'GT11-SN',
		cityId: 'BT09-28166'
	},
	{
		code: 'GCJ',
		regionId: '',
		countryId: 'GT11-ZA',
		cityId: 'BT09-27913'
	},
	{
		code: 'EDI',
		regionId: 'BT10-181:BT10-639',
		countryId: 'GT11-GB',
		cityId: 'BT09-20501'
	},
	{
		code: 'SKB',
		regionId: '',
		countryId: 'GT11-KN',
		cityId: 'BT09-28332'
	},
	{
		code: 'PMO',
		regionId: 'BT10-113',
		countryId: 'GT11-IT',
		cityId: 'BT09-23033'
	},
	{
		code: 'FAO',
		regionId: 'BT10-19:BT10-24:BT10-31',
		countryId: 'GT11-PT',
		cityId: 'BT09-25889'
	},
	{
		code: 'SYD',
		regionId: 'BT10-271',
		countryId: 'GT11-AU',
		cityId: 'BT09-10594'
	},
	{
		code: 'PMC',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-29383'
	},
	{
		code: 'LCA',
		regionId: 'BT10-89',
		countryId: 'GT11-CY',
		cityId: 'BT09-11822'
	},
	{
		code: 'AKL',
		regionId: '',
		countryId: 'GT11-NZ',
		cityId: 'BT09-25347'
	},
	{
		code: 'LEJ',
		regionId: 'BT10-528:BT10-537',
		countryId: 'GT11-DE',
		cityId: 'BT09-13434'
	},
	{
		code: 'POP',
		regionId: 'BT10-344:BT10-345:BT10-346:BT10-900',
		countryId: 'GT11-DO',
		cityId: 'BT09-29080'
	},
	{
		code: 'LAX',
		regionId: 'BT10-282',
		countryId: 'GT11-US',
		cityId: 'BT09-26831'
	},
	{
		code: 'MIR',
		regionId: 'BT10-91:BT10-92:BT10-94',
		countryId: 'GT11-TN',
		cityId: 'BT09-26570'
	},
	{
		code: 'RKT',
		regionId: 'BT10-212:BT10-213',
		countryId: 'GT11-AE',
		cityId: 'BT09-10027'
	},
	{
		code: 'GLA',
		regionId: 'BT10-181',
		countryId: 'GT11-GB',
		cityId: 'BT09-20418'
	},
	{
		code: 'ZAG',
		regionId: 'BT10-699',
		countryId: 'GT11-HR',
		cityId: 'BT09-21756'
	},
	{
		code: 'PNT',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-44240'
	},
	{
		code: 'MAN',
		regionId: 'BT10-182',
		countryId: 'GT11-GB',
		cityId: 'BT09-20046'
	},
	{
		code: 'GYE',
		regionId: 'BT10-385',
		countryId: 'GT11-EC',
		cityId: 'BT09-45293'
	},
	{
		code: 'RAI',
		regionId: '',
		countryId: 'GT11-CV',
		cityId: 'BT09-28306'
	},
	{
		code: 'USH',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-27962'
	},
	{
		code: 'GUA',
		regionId: '',
		countryId: 'GT11-GT',
		cityId: 'BT09-28174'
	},
	{
		code: 'KBV',
		regionId: 'BT10-228:BT10-230:BT10-237',
		countryId: 'GT11-TH',
		cityId: 'BT09-29428'
	},
	{
		code: 'LBA',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20145'
	},
	{
		code: 'MES',
		regionId: '',
		countryId: 'GT11-ID',
		cityId: 'BT09-29474'
	},
	{
		code: 'KGS',
		regionId: 'BT10-61:BT10-73:BT10-88',
		countryId: 'GT11-GR',
		cityId: 'BT09-21421'
	},
	{
		code: 'AUA',
		regionId: 'BT10-1014',
		countryId: 'GT11-AW',
		cityId: 'BT09-10722'
	},
	{
		code: 'RMI',
		regionId: 'BT10-124:BT10-125',
		countryId: 'GT11-IT',
		cityId: 'BT09-22854'
	},
	{
		code: 'LGW',
		regionId: 'BT10-180:BT10-182',
		countryId: 'GT11-GB',
		cityId: 'BT09-11282'
	},
	{
		code: 'TLL',
		regionId: 'BT10-199',
		countryId: 'GT11-EE',
		cityId: 'BT09-15244'
	},
	{
		code: 'DAB',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27055'
	},
	{
		code: 'LPQ',
		regionId: '',
		countryId: 'GT11-LA',
		cityId: 'BT09-42493'
	},
	{
		code: 'SYZ',
		regionId: '',
		countryId: 'GT11-IR',
		cityId: 'BT09-37991'
	},
	{
		code: 'LXA',
		regionId: '',
		countryId: 'GT11-CN',
		cityId: 'BT09-29588'
	},
	{
		code: 'HAJ',
		regionId: 'BT10-475:BT10-484:BT10-485:BT10-537:BT10-748',
		countryId: 'GT11-DE',
		cityId: 'BT09-13909'
	},
	{
		code: 'CMN',
		regionId: 'BT10-96:BT10-97',
		countryId: 'GT11-MA',
		cityId: 'BT09-24534'
	},
	{
		code: 'NAP',
		regionId: 'BT10-118:BT10-119',
		countryId: 'GT11-IT',
		cityId: 'BT09-23111'
	},
	{
		code: 'BZN',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-27440'
	},
	{
		code: 'KLU',
		regionId: '',
		countryId: 'GT11-AT',
		cityId: 'BT09-10358'
	},
	{
		code: 'JRO',
		regionId: 'BT10-390',
		countryId: 'GT11-TZ',
		cityId: 'BT09-45398'
	},
	{
		code: 'HAN',
		regionId: 'BT10-256',
		countryId: 'GT11-VN',
		cityId: 'BT09-27865'
	},
	{
		code: 'NSA',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-10618'
	},
	{
		code: 'GWY',
		regionId: '',
		countryId: 'GT11-IE',
		cityId: 'BT09-22145'
	},
	{
		code: 'STR',
		regionId: 'BT10-405',
		countryId: 'GT11-DE',
		cityId: 'BT09-12388'
	},
	{
		code: 'INV',
		regionId: '',
		countryId: 'GT11-GB',
		cityId: 'BT09-20239'
	},
	{
		code: 'BSL',
		regionId: '',
		countryId: 'GT11-CH',
		cityId: 'BT09-11703'
	},
	{
		code: 'COK',
		regionId: 'BT10-265',
		countryId: 'GT11-IN',
		cityId: 'BT09-52642'
	},
	{
		code: 'BWK',
		regionId: 'BT10-103:BT10-105',
		countryId: 'GT11-HR',
		cityId: 'BT09-29601'
	},
	{
		code: 'SIN',
		regionId: 'BT10-247:BT10-252',
		countryId: 'GT11-SG',
		cityId: 'BT09-26362'
	},
	{
		code: 'DAC',
		regionId: '',
		countryId: 'GT11-BD',
		cityId: 'BT09-28179'
	},
	{
		code: 'BIQ',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-19047'
	},
	{
		code: 'FLR',
		regionId: 'BT10-120',
		countryId: 'GT11-IT',
		cityId: 'BT09-23512'
	},
	{
		code: 'CEI',
		regionId: '',
		countryId: 'GT11-TH',
		cityId: 'BT09-54438'
	},
	{
		code: 'ZAD',
		regionId: 'BT10-100:BT10-101:BT10-106',
		countryId: 'GT11-HR',
		cityId: 'BT09-21757'
	},
	{
		code: 'HVB',
		regionId: '',
		countryId: 'GT11-AU',
		cityId: 'BT09-10716'
	},
	{
		code: 'LIO',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-38225'
	},
	{
		code: 'IAS',
		regionId: '',
		countryId: 'GT11-RO',
		cityId: 'BT09-26090'
	},
	{
		code: 'FNC',
		regionId: 'BT10-32',
		countryId: 'GT11-PT',
		cityId: 'BT09-25872'
	},
	{
		code: 'BLR',
		regionId: 'BT10-265',
		countryId: 'GT11-IN',
		cityId: 'BT09-38338'
	},
	{
		code: 'CIA',
		regionId: 'BT10-118:BT10-119',
		countryId: 'GT11-IT',
		cityId: 'BT09-22827'
	},
	{
		code: 'TRN',
		regionId: 'BT10-121',
		countryId: 'GT11-IT',
		cityId: 'BT09-22488'
	},
	{
		code: 'YYZ',
		regionId: '',
		countryId: 'GT11-CA',
		cityId: 'BT09-11208'
	},
	{
		code: 'BGI',
		regionId: 'BT10-354',
		countryId: 'GT11-BB',
		cityId: 'BT09-28162'
	},
	{
		code: 'MAH',
		regionId: 'BT10-3',
		countryId: 'GT11-ES',
		cityId: 'BT09-43680'
	},
	{
		code: 'ANA',
		regionId: '',
		countryId: 'GT11-US',
		cityId: 'BT09-26728'
	},
	{
		code: 'MPL',
		regionId: '',
		countryId: 'GT11-FR',
		cityId: 'BT09-17875'
	},
	{
		code: 'THR',
		regionId: '',
		countryId: 'GT11-IR',
		cityId: 'BT09-28129'
	},
	{
		code: 'DPS',
		regionId: 'BT10-248:BT10-249',
		countryId: 'GT11-ID',
		cityId: 'BT09-32157'
	},
	{
		code: 'LLW',
		regionId: '',
		countryId: 'GT11-MW',
		cityId: 'BT09-28203'
	},
	{
		code: 'LHR',
		regionId: 'BT10-180:BT10-182:BT10-639',
		countryId: 'GT11-GB',
		cityId: 'BT09-11282'
	},
	{
		code: 'RGN',
		regionId: 'BT10-259',
		countryId: 'GT11-MM',
		cityId: 'BT09-39003'
	},
	{
		code: 'ZAL',
		regionId: '',
		countryId: 'GT11-CL',
		cityId: 'BT09-29385'
	},
	{
		code: 'JKG',
		regionId: '',
		countryId: 'GT11-SE',
		cityId: 'BT09-26290'
	},
	{
		code: 'MEX',
		regionId: 'BT10-372:BT10-373:BT10-374:BT10-907',
		countryId: 'GT11-MX',
		cityId: 'BT09-29100'
	},
	{
		code: 'LUN',
		regionId: '',
		countryId: 'GT11-ZM',
		cityId: 'BT09-28164'
	},
	{
		code: 'XRY',
		regionId: 'BT10-18:BT10-19:BT10-20',
		countryId: 'GT11-ES',
		cityId: 'BT09-16033'
	},
	{
		code: 'EZE',
		regionId: '',
		countryId: 'GT11-AR',
		cityId: 'BT09-27984'
	},
	{
		code: 'NRT',
		regionId: 'BT10-782',
		countryId: 'GT11-JP',
		cityId: 'BT09-24371'
	},
	{
		code: 'MUC',
		regionId: 'BT10-411:BT10-425:BT10-713:BT10-716',
		countryId: 'GT11-DE',
		cityId: 'BT09-13179'
	},
	{
		code: 'CYR',
		regionId: '',
		countryId: 'GT11-FM',
		cityId: 'BT09-43405'
	}
];
